import { useMemo } from 'react';

import { t } from '@lingui/macro';

import { getFormattedCurrency, getMainPrice, STANDARD_PRICE_SELECT_VALUE } from '../utils/business/prices';

const useReadPriceChoices = (variant, totalParticipants, mainPriceWording) => {
  const choices = useMemo(() => getPriceChoices(variant, totalParticipants, mainPriceWording), [variant.participant, totalParticipants]);
  return choices;
};

export default useReadPriceChoices;

// This fills the select containing all available prices
// The first option of the select is the main price : either standard or discount
const getPriceChoices = (variant, totalParticipants, mainPriceWording) => {
  const mainPriceChoice = getMainPriceChoice(variant, totalParticipants, mainPriceWording);

  const choices = [mainPriceChoice];

  for (const priceVariation of variant.custom_prices) {
    if (priceVariation.participant_threshold) continue;

    choices.push({
      label: priceVariation.label,
      value: priceVariation.id,
      price: getFormattedCurrency(priceVariation.computed_price),
    });
  }
  return choices;
};

const getMainPriceChoice = (variant, totalParticipants, mainPriceWording) => {
  const mainPriceData = getMainPrice(variant.standardPrice, totalParticipants ?? variant.participant, variant.custom_prices);

  const formattedPriceValue = getFormattedCurrency(mainPriceData.priceValue);

  let mainPriceLabel = null;
  if (mainPriceData.priceVariationId === STANDARD_PRICE_SELECT_VALUE) {
    mainPriceLabel = mainPriceWording ?? t`Standard price`;
  } else {
    mainPriceLabel = t`Special price`;
  }

  return {
    label: mainPriceLabel,
    value: mainPriceData.priceVariationId,
    price: formattedPriceValue,
  };
};
